import { memo } from "react";

import { Skeleton } from "@mui/material";
import { Box, ContentRepeater, FlexColBox } from "../../../common/components";
import { STUDIO_TOOLBAR_HEIGHT } from "../../../components/StudioToolbar/StudioToolbar";
import { createStyles, palette, spacing } from "../../../styles/theme";
import { useThemeBreakpoints } from "../../../utils/themeUtils";

const styles = createStyles({
  wrapper: {
    height: "100%",
    maxHeight: `calc(100vh - ${STUDIO_TOOLBAR_HEIGHT})`,
    "&>div": {
      height: "100%",
    },
    position: "relative",
  },
  container: {
    minHeight: { xs: "auto", lg: `calc(100vh - ${STUDIO_TOOLBAR_HEIGHT})` },
    display: "flex",
    flexDirection: "column",
    p: { xs: spacing.mediumMobile, lg: spacing.mediumDesktop },
    alignItems: "center",
    minWidth: { xs: "100%", lg: "324px" },
    maxWidth: { xs: "100vw", lg: "324px" },
    borderRight: { xs: "none", lg: `1px solid ${palette.grey.lightGrey}` },
    gap: { xs: spacing.regularMobile, lg: spacing.regularDesktop },
    height: "100%",
  },
});

const StudioLeftSidebarSkeleton = () => {
  const { isMobile } = useThemeBreakpoints();

  return (
    <Box sx={styles.container}>
      <FlexColBox
        gap={{ xs: spacing.wrapperMobile, lg: spacing.regularDesktop }}
        fullWidth
        flexDirection={{ xs: "row", lg: "column" }}
      >
        <FlexColBox
          gap={{ xs: spacing.wrapperMobile, lg: spacing.xsDesktop }}
          flexDirection={{ xs: "row", lg: "column" }}
        >
          <ContentRepeater repeatCount={6}>
            {!isMobile ? (
              <Skeleton
                variant="rounded"
                width={"100%"}
                height={48}
                sx={{ borderRadius: "8px" }}
              />
            ) : (
              <Skeleton
                variant="rounded"
                width={56}
                height={56}
                sx={{ borderRadius: "8px" }}
              />
            )}
          </ContentRepeater>
        </FlexColBox>
        {!isMobile && (
          <FlexColBox
            gap={{ xs: spacing.wrapperMobile, lg: spacing.smallDesktop }}
            flexDirection={{ xs: "row", lg: "column" }}
          >
            <FlexColBox
              gap={{ xs: spacing.mediumMobile, lg: spacing.mediumDesktop }}
            >
              <Skeleton variant="text" width={100} height={24} />
              <Skeleton
                variant="rounded"
                width={"100%"}
                height={40}
                sx={{ borderRadius: "8px" }}
              />
            </FlexColBox>
            <ContentRepeater repeatCount={3}>
              <Skeleton
                variant="rounded"
                width={"100%"}
                height={48}
                sx={{ borderRadius: "8px" }}
              />
            </ContentRepeater>
          </FlexColBox>
        )}
      </FlexColBox>
    </Box>
  );
};

export default memo(StudioLeftSidebarSkeleton);
